/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * A React component for play circle icon.
 *
 * @author Ramani Govindaraju
 */
const PlayCircle = props => (
  <SvgIcon viewBox="0 0 90 90" {...props}>
    <path
      d="M30 28.125a1.877 1.877 0 0 1 2.715-1.676l33.75 16.875A1.878
      1.878 0 0 1 67.5 45c0 .709-.401 1.358-1.035 1.676l-33.75 16.875a1.865
      1.865 0 0 1-1.826-.082A1.877 1.877 0 0 1 30 61.875v-33.75zM45 90c24.814
      0 45-20.186 45-45S69.814 0 45 0 0 20.186 0 45s20.186 45 45 45z"
    />
  </SvgIcon>
);

export default PlayCircle;



// WEBPACK FOOTER //
// ./src/js/icons/PlayCircle.jsx